import { Box, Checkbox, CheckboxProps } from '@mui/material';
import styles from './BaseCheckbox.module.scss';
import classNames from 'classnames/bind';

type BaseCheckboxprops = CheckboxProps & {
  label?: string;
};

const cx = classNames.bind(styles);
const icon = () => {
  return (
    <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.8333 15.9167H5.83333C3.82397 15.9167 2.61253 15.5102 1.8845 14.7822C1.15647 14.0541 0.75 12.8427 0.75 10.8333V5.83333C0.75 3.82397 1.15647 2.61253 1.8845 1.8845C2.61253 1.15647 3.82397 0.75 5.83333 0.75H10.8333C12.8427 0.75 14.0541 1.15647 14.7822 1.8845C15.5102 2.61253 15.9167 3.82397 15.9167 5.83333V10.8333C15.9167 12.8427 15.5102 14.0541 14.7822 14.7822C14.0541 15.5102 12.8427 15.9167 10.8333 15.9167Z'
        stroke='#B7C0CA'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

const checkedIcon = () => {
  return (
    <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.83333 16.6667H10.8333C15 16.6667 16.6667 15 16.6667 10.8333V5.83333C16.6667 1.66667 15 0 10.8333 0H5.83333C1.66667 0 0 1.66667 0 5.83333V10.8333C0 15 1.66667 16.6667 5.83333 16.6667Z'
        fill='#007AFC'
      />
      <path
        d='M4.7915 8.33343L7.14984 10.6918L11.8748 5.9751'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

const BaseCheckbox = (props: BaseCheckboxprops) => {
  const { label = '', ...restProps } = props;

  return (
    <Box className={cx('checkbox-container')}>
      <Checkbox icon={icon()} checkedIcon={checkedIcon()} {...restProps} />
      {label}
    </Box>
  );
};

export default BaseCheckbox;
